import React from 'react';
import { makeStyles } from '~/UIKit/Style';

const useStyles = makeStyles((theme) => ({
  ItemCreationWrapperContainer: {
    display: 'flex',
    [theme.breakpoints.down('md')]: {
      display: 'inherit',
    },
  },
}));

interface IItemCreationWrapperProps {
  children: React.ReactNode[] | React.ReactNode;
  showAll?: boolean;
}

export const ItemCreationWrapper = ({
  children = [],
  showAll = false,
}: IItemCreationWrapperProps) => {
  const { classes } = useStyles();
  const showZero = Array.isArray(children) && !showAll && children.length;
  return (
    <div className={classes.ItemCreationWrapperContainer}>
      {showZero ? children?.[0] : children}
    </div>
  );
};
